<template>
    <v-container class="ma-0 pa-0">

        <v-row class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-4" align-self="start" align="left">
                <p class="card-title" v-html="getTitle" />
                <p class="desc" >
                    {{ getDescription }}
                </p>
            </v-col>
        </v-row>

        <v-row class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0" align-self="start" align="center">
                <img
                    :src="getImage"
                    :alt="`${id} 단계 운동법`"
                    class="image-cardio"
                >
            </v-col>
        </v-row>

    </v-container>
</template>
<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            isInsufficientExercise: {
                type: Boolean,
                required: true
            },
            id: {
                type: Number,
                required: true
            }
        },
        computed: {
            getTitle() {
                const index = this.id - 1
                if(this.isInsufficientExercise) {
                    return this.$t(`exerciseGuide.low.weight.exercise[` + index + `]`)
                }
                else {
                    return this.$t(`exerciseGuide.high.weight.exercise[` + index + `]`)
                }
            },
            getDescription() {
                if(this.isInsufficientExercise) {

                }
                else {

                }
            },
            getImage() {
                if(this.isInsufficientExercise) {
                    switch(this.id) {
                        case 1: return require('@/assets/images/img-exercise-muscle-01.png')
                        case 2: return require('@/assets/images/img-exercise-muscle-02.png')
                        case 3: return require('@/assets/images/img-exercise-muscle-03.png')
                    }
                }
                else {
                    switch(this.id) {
                        case 1: return require('@/assets/images/img-exercise-muscle-01.png')
                        case 2: return require('@/assets/images/img-exercise-muscle-04.png')
                        case 3: return require('@/assets/images/img-exercise-muscle-05.png')
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
<style scoped>
    div {
        font-weight: bold;
    }
    .number {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 30px;
        margin-top: 20px;
        margin-bottom: 12px;
    }
    .card-title {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 18px;
        margin-bottom: 12px;
        color: #3f6fff;
        text-align: left;
    }
    
    .cardio-title {
        font-family: "NanumSquare", sans-serif;
        font-weight: bolder;
        font-size: 18px;
        color: #3f6fff;
    }
    
    .desc {
        font-family: "NanumSquare", sans-serif;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.6px;
        color: #475b82;
    }

    .image-cardio {
        width: 80vw;
    }

    @media screen and (min-width: 501px) {
        .image-cardio {
            width: 80%;
        }
    }

    .separator {
        height: 1px;
        width: 100%;
        background-color: black;
        margin-bottom: 40px;
        opacity: 0.1;
    }
</style>
